<div class="folder-info-container" *ngIf="clinicMessagingLoaded$ | async">
  <salve-clinic-messaging-dashboard
    [language]="selectedLanguage$ | async"
    [clinic_token]="xSalveClinicToken$ | async"
  ></salve-clinic-messaging-dashboard>
</div>
